import { render, staticRenderFns } from "./VoiceCommandsModal.vue?vue&type=template&id=659197f6&scoped=true"
import script from "./VoiceCommandsModal.vue?vue&type=script&lang=js"
export * from "./VoiceCommandsModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceCommandsModal.vue?vue&type=style&index=0&id=659197f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659197f6",
  null
  
)

export default component.exports